<template>
  <v-card flat class="pa-6">
    <v-card-title class="text-h6 primary--text mb-6">
      {{ $t("game_images_and_assets") }}
    </v-card-title>

    <v-card-text v-if="gameConfig && gameConfig.images">
      <v-row dense>
        <v-col v-for="(field, key) in imagesSchema" :key="key" cols="12" md="6">
          <h5 class="mb-3 font-weight-medium">
            {{ field.label }}
            {{ field.type === "imageArray" ? "(چند تصویر)" : "" }}
          </h5>

          <pic-selector
            v-if="field.type === 'image'"
            :field.sync="gameConfig.images[key]"
            @update:field="updateImage(key, $event)"
            one-pic
            single
            :edit-name="false"
            :default-cat-name="field.label"
          />

          <pic-selector
            v-else-if="field.type === 'imageArray'"
            v-model="gameConfig.images[key]"
            @input="syncChanges"
            :edit-img="false"
            :edit-name="false"
            single
            :max="key === 'traps' ? 20 : 8"
            :default-cat-name="field.label"
          />
        </v-col>

        <!-- اگر هیچ فیلدی نبود -->
        <v-col v-if="!Object.keys(imagesSchema).length" cols="12">
          <v-alert type="info" text prominent>
            تصویری برای این نوع بازی تعریف نشده است.
          </v-alert>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import PicSelector from "@/view/components/UploadCenter/picSelector.vue";

export default {
  name: "TabImages",
  components: { PicSelector },
  props: {
    value: { type: Object, required: true },
    schema: { type: Object, required: true },
  },
  computed: {
    gameConfig: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    gameType() {
      return this.gameConfig?.type || null;
    },
    imagesSchema() {
      return this.schema?.imagesConfig || {};
    },
  },
  methods: {
    updateImage(key, newVal) {
      // Use Vue.set to ensure reactivity
      this.$set(this.gameConfig.images, key, newVal);
      this.$emit("input", { ...this.gameConfig });
    },
    syncChanges() {
      this.$emit("input", { ...this.gameConfig });
    },
  },
};
</script>
